import { SportsEffects } from './sports.effects';
import { SportActiveEffects } from './sport-active.effects';
import { ContextEffects } from './context.effects';
import { HeaderEffects } from './header.effects';
import { AuthEffects } from './authentication.effects';
import { InternetEffects } from './internet.effects';
import { SessionEffects } from './session.effects';
import { ContributorJobsEffects } from './contributor-jobs.effects';

export const rootEffects: any[] = [ 
    AuthEffects, 
    InternetEffects,
    HeaderEffects,
    ContextEffects,
    SportActiveEffects,
    SportsEffects,
    SessionEffects,
    ContributorJobsEffects

];
